import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-search',
  styleUrls: ['./search.component.scss'],
  templateUrl: './search.component.html'
})
export class SearchComponent {}
